module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC02_ua.a6c72ab2.webp";